import { render, staticRenderFns } from "./BreathingExercise.vue?vue&type=template&id=3702d56a&"
import script from "./BreathingExercise.vue?vue&type=script&lang=js&"
export * from "./BreathingExercise.vue?vue&type=script&lang=js&"
import style0 from "./BreathingExercise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports